import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Leaf } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/auth"); return; }
    (async () => {
      try {
        await googleSession(sid);
        window.history.replaceState(null, "", "/app");
        navigate("/app");
      } catch (e) {
        toast.error(apiErr(e));
        navigate("/auth");
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <div className="flex h-12 w-12 animate-pulse items-center justify-center rounded-full bg-[#4A7c59] text-white"><Leaf className="h-6 w-6" /></div>
      <p className="text-muted-foreground">Signing you in…</p>
    </div>
  );
}
